import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
    selector: 'dynfield-select',
    template: require('./dynamic-fields.select.component.html')
})
export class DynamicFieldSelectComponent implements OnInit, OnChanges {
    @Input() version: number;
    @Input() field: any;
    @Input() fieldsOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: any;
    @Input() workflow: any;
    @Input() callback: any;

    @Output() fieldDataChange = new EventEmitter<any>();

    public error: any = {};
    public isRequired: boolean;
    public selectedElement: any;
    public fieldData: any;
    public fieldOptions: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit(): void {
        this.isRequired = this.dynamicFieldsService.isRequired(this);
        this.selectedElement = this.dynamicFieldsService.getNoneElement();
        if (this.fieldData === undefined) {
            this.fieldData = "";
        }
        this.setFieldOptions();
        this.setInitialFieldData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.error = this.dynamicFieldsService.setError(
            changes?.fieldError?.currentValue, this.field
        );
        //this.setFieldOptions();
        //this.setInitialFieldData();
    }

    private setFieldOptions(): void {
        this.fieldOptions = this.dynamicFieldsService.sortFieldElements(
            this.dynamicFieldsService.getFieldOptions(
                this.fieldsOptions, this.field, this.workflow
            )
        );

        if (Array.isArray(_.get(this.fieldOptions, 'fieldElements', false))) {
            this.fieldOptions.fieldElements = this.dynamicFieldsService.addNoneElement(this.fieldOptions);
        }
    }

    updateErrorStatus() {
        this.error.hasError = false;
    }

    private setInitialFieldData() {
        let id = _.get(this.field.fieldData, 'id', 0);
        let element = _.find(this.fieldOptions.fieldElements, {id: id});

        if (!_.isEmpty(element)) {
            this.fieldData = element.id;
        }
    }

    setFieldData($event) {
        this.error.hasError = false;
        let element = _.find(this.fieldOptions.fieldElements, (item) => {
            return item.id == this.fieldData;
        });

        if (!_.isEmpty(element)) {
            this.field.fieldData = element;
        }
    }
}
